import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, remove } from "firebase/database";
import "../../css/UserQueries.css"; // create styling as needed
import LoaderComponent from "../../component/LoaderComponent";
import ContactUsModalView from "../../component/ContactUsModalView";
import { toast, ToastContainer } from "react-toastify";
import { useAdminAuth } from "../../component/AdminUserPresent";

const UserQueries = () => {
	const [queries, setQueries] = useState([]);
	const [loader, setLoader] = useState(false);
	const [selectedQuery, setSelectedQuery] = useState(null); // for modal
	const isAdmin = useAdminAuth();

	useEffect(() => {
		if (!isAdmin) return;
		setLoader(true);
		const db = getDatabase();
		const queriesRef = ref(db, "customerquery"); // path to your queries

		const unsubscribe = onValue(queriesRef, (snapshot) => {
			if (snapshot.exists()) {
				const data = snapshot.val();
				const formatted = Object.keys(data).map((key) => ({
					id: key,
					...data[key],
				}));
				setQueries(formatted.reverse());
			} else {
				setQueries([]);
			}
			setLoader(false);
		});

		return () => unsubscribe();
	}, []);

	const handleDelete = async (id) => {
		const confirmDelete = window.confirm(
			"Are you sure you want to delete this query?",
		);

		if (!confirmDelete) return;

		try {
			const db = getDatabase();
			await remove(ref(db, `customerquery/${id}`));
			toast.success("Query deleted successfully...");
		} catch (error) {
			console.error("Delete failed:", error);
			toast.error("Failed to delete queryy...");
		}
	};

	return (
		<div className="user-queries-container">
			{loader && <LoaderComponent />}
			<ToastContainer />

			<div className="text-center py-4">
				<h2>User Queries</h2>
			</div>
			<div className="query-cards py-3">
				{queries.map((q) => (
					<div key={q.id} className="query-card">
						<div className="text-right delete-query">
							<button
								className="delete-btn"
								onClick={() => handleDelete(q.id)}
								title="Delete"
							>
								✕
							</button>
						</div>
						<p>
							<strong>Name:</strong> {q.name}
						</p>
						<p>
							<strong>Email:</strong> {q.email}
						</p>
						<button
							className="query-details-btn"
							onClick={() => setSelectedQuery(q)}
						>
							Details
						</button>
					</div>
				))}
			</div>

			{/* Modal */}
			<ContactUsModalView
				isOpen={!!selectedQuery}
				onClose={() => setSelectedQuery(null)}
			>
				{selectedQuery && (
					<div className="query-details">
						<h3>Query Details</h3>
						<div className="query-row">
							<span>Company Name:</span>
							<span>{selectedQuery.companyName}</span>
						</div>
						<div className="query-row">
							<span>Country:</span>
							<span>{selectedQuery.country}</span>
						</div>
						<div className="query-row">
							<span>Email:</span>
							<span className="break-word">
								{selectedQuery.email}
							</span>
						</div>
						<div className="query-row">
							<span>Customization:</span>
							<span>{selectedQuery.isInterested}</span>
						</div>
						<div className="query-row">
							<span>Phone:</span>
							<span>{selectedQuery.phone}</span>
						</div>
						<div className="query-row">
							<span>Product:</span>
							<span>{selectedQuery.productTitle}</span>
						</div>
						<div className="query-row">
							<span>ProductId:</span>
							<span>{selectedQuery.productId}</span>
						</div>
						<div className="query-row">
							<span>Message:</span>
							<span className="scrollable-message">
								{selectedQuery.message}
							</span>
						</div>
					</div>
				)}
			</ContactUsModalView>
		</div>
	);
};

export default UserQueries;
